import { useRef } from 'react';

/**
 * Returns a ref that always holds the latest value.
 *
 * Useful inside long-running async callbacks (SSE streams, timers) where
 * closure-captured values go stale when React state or props change.
 */
export const useLatestRef = (value) => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};
